import { useState } from 'react';
import { useTheme } from 'styled-components';
import { Client } from '../../../2_domain/client/client';
import { OneLineBoxContainer } from '../../core/components/box/boxContainer';
import Column from '../../core/components/box/column';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import LXMiddleButton from '../../core/components/buttons/lxMiddleButton';
import { LXbody, LXh2, LXh3, LXh5 } from '../../core/texts/lxText';
import ClientForm from './clientForm';

interface ClientEditDialogProps {
  client: Client;
  onCancel: () => Promise<void>;
  onSave: (client: Client) => Promise<void>;
}

export const ClientEditDialog = (props: ClientEditDialogProps) => {
  const theme = useTheme();
  const [isClientValid, setIsClientValid] = useState(true);
  const [newClient, setNewClient] = useState(props.client);

  return (
    <Column>
      <LXh2>{theme.texts.clientInformation}</LXh2>
      <SizedBox height={40}></SizedBox>
      <LXh5>{`${theme.texts.clientNo} ${props.client.clientSerial}`}</LXh5>
      <SizedBox height={24}></SizedBox>
      <ClientForm
        client={props.client}
        onClientChange={setNewClient}
        onClientValid={setIsClientValid}
      ></ClientForm>
      <SizedBox height={30}></SizedBox>
      <Row justifyContent="center">
        <LXMiddleButton onClick={props.onCancel} kind={'secondary'}>
          {theme.texts.cancel}
        </LXMiddleButton>
        <SizedBox width={8}></SizedBox>
        <LXMiddleButton
          onClick={() => props.onSave(newClient)}
          disabled={!isClientValid}
        >
          {theme.texts.save}
        </LXMiddleButton>
      </Row>
    </Column>
  );
};

interface ClientDeleteDialogProps {
  client: Client;
  onDeleteClientAndContent: () => Promise<void>;
  onDeleteClient: () => Promise<void>;
}

export const ClientDeleteDialog = (props: ClientDeleteDialogProps) => {
  const theme = useTheme();

  return (
    <Column justifyContent="space-between" alignItems="center">
      <SizedBox height={30}></SizedBox>
      <LXh3>{theme.texts.deleteClient}</LXh3>
      <SizedBox height={8}></SizedBox>
      <LXbody color={theme.colors.caption}>
        {theme.texts.areYouSureYouWantToDeleteThisClient}
      </LXbody>
      <LXbody color={theme.colors.caption}>
        {theme.texts.itWillBePermanentlyDeleted}
      </LXbody>
      <SizedBox height={24}></SizedBox>
      <OneLineBoxContainer>
        <LXbody>{`#${props.client.clientSerial} / ${props.client.name}`}</LXbody>
      </OneLineBoxContainer>
      <SizedBox height={30}></SizedBox>
      <Row justifyContent="center">
        <LXMiddleButton
          onClick={props.onDeleteClientAndContent}
          kind={'secondary'}
        >
          {theme.texts.deleteClientAndContent}
        </LXMiddleButton>
        <SizedBox width={8}></SizedBox>
        <LXMiddleButton onClick={props.onDeleteClient}>
          {theme.texts.deleteClient}
        </LXMiddleButton>
      </Row>
    </Column>
  );
};
